/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';

export class FrameworkUtrApi extends BaseApi {
  endPoint: string = '/api/admin/framework-utrs';
}
